export default __webpack_public_path__ + "static/article1-e52c29a64297e6a7c381a018b0d8f4f2.png";